import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatInput } from './chat-input';
import { ProjectSelector } from './ProjectSelector';
import { useProjectStore } from '@/stores/useProject.store';
import { toast } from 'sonner';

export function NewChat() {
  const navigate = useNavigate();
  const [isCreatingChat, setIsCreatingChat] = useState(false);

  const handleFirstMessage = async content => {
    if (!content?.content?.trim() && (!content.attachments || content.attachments.length === 0)) return;

    if (isCreatingChat) return;

    setIsCreatingChat(true);

    try {
      const { createChat } = useProjectStore.getState();
      const newChat = await createChat();

      if (!newChat?.permitChat?._id) {
        throw new Error('Failed to create chat');
      }
      navigate(`/citypermit/project/chat/${newChat.permitChat._id}`, {
        state: { initialMessage: content },
        replace: true,
      });
    } catch (error) {
      console.error('Error creating chat:', error);
      toast.error('Failed to create chat. Please try again.');
      setIsCreatingChat(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full w-full px-4">
      {/* Kelly avatar */}
      {/* <img src="/kelly.png" alt="Kelly Avatar" className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 object-cover mb-1" />
            <p className="text-sm sm:text-base md:text-lg font-medium text-white mb-4 sm:mb-5">Hey, I'm Kelly!</p> */}

      {/* Headings */}
      <div className="my-4 sm:my-6 w-full">
        <p className="text-center text-sm sm:text-base md:text-xl lg:text-2xl xl:text-[2rem] text-white leading-snug xl:leading-[50px] font-baloo-2-thin">
          Submit Your Permit Application in Just 2–3 Minutes
        </p>
        <h1 className="text-center text-xl sm:text-2xl md:text-xl lg:text-[2rem] xl:text-[2.5rem] font-baloo-2-thin text-white leading-tight xl:leading-[50px] my-2 sm:my-[7px]">
          What type of city permit would you like to zermit today?
        </h1>
      </div>

      {/* Subtext */}
      <p className="text-center text-sm text-gray-400 mb-4">
        Supports OTC (over-the-counter) and simple like-for-like permits
      </p>

      {/* Project selector */}
      {/* <div className="w-full max-w-3xl py-2">
                <ProjectSelector onSelect={option => handleFirstMessage({ content: option, attachments: [] })} />
            </div> */}

      {/* Input box */}
      <div className="w-full max-w-3xl">
        <ChatInput onSendMessage={handleFirstMessage} disabled={isCreatingChat} showActions={false} />
      </div>

      {/* Legal text */}
      <p className="mt-3 text-center text-xs text-white/50 font-light">
        By messaging Zermit AI, you agree to our{' '}
        <span className="underline cursor-pointer" onClick={() => navigate('/terms')}>
          Terms
        </span>{' '}
        and have read our{' '}
        <span className="underline cursor-pointer" onClick={() => navigate('/terms')}>
          Privacy Policy.
        </span>
      </p>
    </div>
  );
}
